<div
  class="customer-agreement-item"
  tabindex="0"
  [ngClass]="{ 'is-disabled': isInFlightOrder, 'has-navigation': hasNavigation }"
>
  @if (hasIcon) {
    <mat-icon class="customer-agreement-icon" [svgIcon]="iconName" />
  }
  <div class="customer-agreement-information">
    <div class="customer-agreement-heading">
      <span class="customer-agreement-main-heading">{{ mainHeading }}</span>
      @if (!!subHeading) {
        <span class="customer-agreement-sub-heading">{{ subHeading }}</span>
      }
    </div>
    <ng-content />
  </div>
  <div class="customer-agreement-price">
    @if (isFamilyBenefit) {
      Inkludert i iceFamilie
    }
    @if (originalPrice > 0) {
      <div class="price-section">
        <span class="original-price">
          {{ originalPrice | priceFormat: PriceType.Monthly }}
        </span>
        @if (monthlyPrice >= 0) {
          {{ monthlyPrice | priceFormat: PriceType.Monthly }}
        }
      </div>
    } @else if (monthlyPrice >= 0) {
      {{ monthlyPrice | priceFormat: PriceType.Monthly }}
    }
  </div>
  @if (!isInFlightOrder) {
    @if (hasNavigation) {
      <mat-icon class="arrow-icon" [svgIcon]="IconNames.ice_arrow_right" />
    } @else {
      <button
        data-testid="expand-customer-agreement-button"
        mat-icon-button
        [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()"
      >
        <mat-icon class="menu-icon">more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <ng-content select="[menu-content]" />
      </mat-menu>
    }
  }
</div>
